module.exports = __webpack_public_path__ + "static/media/onboarding-pages.35390a84.mp4";